import {
  HelpdeskAttachment,
  HelpdeskMessage,
  TicketCategory,
  TicketPriority,
  TicketStatus,
} from "@/types/helpdesk/Helpdesk";

export const HELPDESK_REALTIME_EVENT = "edms-helpdesk-update";
export const HELPDESK_REALTIME_CONNECTED_EVENT = "edms-helpdesk-connected";
export const ASSISTANT_AVATAR_UPDATED_EVENT = "edms-assistant-avatar-updated";

export interface HelpdeskRealtimeEvent {
  eventId: string;
  tenantId?: string | null;
  eventType: string;
  ticketId: string;
  ticketNumber: string;
  subject: string;
  category: TicketCategory;
  source: string;
  status: TicketStatus;
  previousStatus?: TicketStatus | null;
  priority: TicketPriority;
  assigneeId?: string | null;
  assigneeName?: string | null;
  requesterId?: string | null;
  requesterName: string;
  actorId?: string | null;
  createdAt: string;
  ticketVersion: number;
  ticketUpdatedAt: string;
  waitingUserSince?: string | null;
  autoCloseAt?: string | null;
  message?: HelpdeskMessage | null;
  attachment?: HelpdeskAttachment | null;
  occurredAt: string;
}
